import { render, staticRenderFns } from "./EditSecurityRole.vue?vue&type=template&id=3ea265c6&scoped=true&"
import script from "./EditSecurityRole.vue?vue&type=script&lang=js&"
export * from "./EditSecurityRole.vue?vue&type=script&lang=js&"
import style0 from "./EditSecurityRole.vue?vue&type=style&index=0&id=3ea265c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ea265c6",
  null
  
)

export default component.exports